const setSiteTitle=(title)=>{
    document.title=title;
}

export {setSiteTitle};